// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.

// Feature flag keys. Use these instead of bare strings so a typo is an
// unresolved identifier rather than a flag that silently reads as undefined.
export const SKIP_MAKE_IN_MODEL_TITLE_FLAG = 'enable-skip-make-in-model-title';
